import { RouteAction } from '@design/buttons/action-config';
import { ActiveSecurityContextStateService } from '@security/active-security/active-security-context.state-service';
import { BureauProfile } from '@app/bureau/bureau-profile';
import { bureauRoutes } from '@app/bureau/bureau-routes';
import { Router } from '@angular/router';
import { FeatureFlagService } from '@feature-flags/feature-flag.service';

export function getBureauNavigationLinks(
  bureau: BureauProfile,
  activeSecurity: ActiveSecurityContextStateService,
  router: Router,
  featureFlagService: FeatureFlagService
) {
  const bureauLinks: RouteAction[] = [];

  if (bureau == null) {
    return bureauLinks;
  }

  const isBureauAdmin = activeSecurity.hasApplicationAuthorityTo('EditBureaux');

  featureFlagService.getValue('bureauDataMining').then((dataMiningVisible) => {
    if (dataMiningVisible && (activeSecurity.hasBureauProfileAuthorityTo('IsBureauUser') || isBureauAdmin)) {
      bureauLinks.push({
        label: 'Dashboard',
        route: bureauRoutes.dashboard,
        feature: 'BureauDashboard',
        anyBureauPermissions: ['Any']
      });
    }

    if (dataMiningVisible && (activeSecurity.hasBureauProfileAuthorityTo('ViewBureauReports') || isBureauAdmin)) {
      bureauLinks.push({
        label: 'Reports',
        route: bureauRoutes.reports,
        feature: 'BureauReports',
        anyBureauPermissions: ['Any']
      });
    }

    if (bureau.teamsEnabled && (activeSecurity.hasBureauProfileAuthorityTo('IsBureauUser') || isBureauAdmin)) {
      bureauLinks.push({
        label: 'Teams',
        route: bureauRoutes.teams,
        feature: 'BureauTeams',
        anyBureauPermissions: ['Any']
      });
    }

    if (activeSecurity.hasBureauProfileAuthorityTo('IsBureauUser') || isBureauAdmin) {
      bureauLinks.push({
        label: 'Organisations',
        route: bureauRoutes.organisations,
        feature: 'BureauOrganisations',
        execute: (data?: any) => {
          router.navigateByUrl(bureauRoutes.organisations).then();
        },
        anyBureauPermissions: ['IsBureauUser']
      });
    }

    if (activeSecurity.hasBureauProfileAuthorityTo('EditBureauUsers') || isBureauAdmin) {
      bureauLinks.push({
        label: 'Bureau Users',
        route: bureauRoutes.users,
        feature: 'BureauUsers',
        anyBureauPermissions: ['EditBureauUsers']
      });
    }
  });

  return bureauLinks;
}
